/**
 * Simple in-memory cache for Supabase queries
 * Prevents repeated DB calls when navigating between pages
 */
const cache = new Map()
const TTL = 60_000 // 1 minute

export function getCached(key) {
  const entry = cache.get(key)
  if (!entry) return null
  if (Date.now() - entry.ts > TTL) { cache.delete(key); return null }
  return entry.data
}

export function setCached(key, data) {
  cache.set(key, { data, ts: Date.now() })
}

export function invalidate(key) {
  // invalidate exact key or all keys starting with prefix
  for (const k of cache.keys()) {
    if (k === key || k.startsWith(key)) cache.delete(k)
  }
}

export function invalidateAll() {
  cache.clear()
}
